<template>
	<Pie 
		ref="chart"
		:data="computedData"
		:options="options"
		:plugins="plugins"
		/>
</template>
<script>
import { Pie } from 'vue-chartjs'
export default {
	name: 'PieChartSimple',
	components: {
		Pie
	},
	props: {
		index: String,
		data: {
			type: Object,
			default: {}
		},
		options: {
			type: Object,
			default: {}
		},
		plugins: {
			type: Array,
			default: []
		},
		hasData: {
			type: Boolean,
			default: false
		},
		feTheme: {
			type: Object,
			default: {
				charts_no_data_text: 'No data'
			}
		}
	},
	computed: {
		computedData() {
			if ( ! this.hasData ) {
				let data = JSON.parse(JSON.stringify(this.data));
				data.datasets = [
							{
								label: this.feTheme.charts_no_data_text,
								data: [1, 1],
								borderColor: '#c1d2c1',
			                    backgroundColor: '#d1d1d1',
							}
						]
				data.labels = [ this.feTheme.charts_no_data_text ]
				return data
			}
			return this.data
		}
	}
}
</script>